'use client';
import { useEffect } from 'react';
import Script from 'next/script';
import { usePathname } from 'next/navigation';

// Extend Window interface for Tawk.to
declare global {
  interface Window {
    Tawk_API?: Record<string, unknown>;
    Tawk_LoadStart?: Date;
  }
}

const TawkToChat = () => {
  const TAWK_PROPERTY_ID = process.env.NEXT_PUBLIC_TAWK_PROPERTY_ID;
  const TAWK_WIDGET_ID = process.env.NEXT_PUBLIC_TAWK_WIDGET_ID;
  const pathname = usePathname();

  useEffect(() => {
    // Initialize Tawk_API
    if (typeof window !== 'undefined') {
      window.Tawk_API = window.Tawk_API || {};
      window.Tawk_LoadStart = new Date();
    }
  }, []);

  // Hide Tawk on Sanity Studio
  if (pathname.startsWith('/blog-admin')) {
    return null;
  }

  // Don't render if env variables are missing
  if (!TAWK_PROPERTY_ID || !TAWK_WIDGET_ID) {
    console.warn('Tawk.to: Missing environment variables');
    return null;
  }

  return (
    <>
      <Script
        id="tawk-to-script"
        strategy="lazyOnload"
        src={`https://embed.tawk.to/${TAWK_PROPERTY_ID}/${TAWK_WIDGET_ID}`}
      />
    </>
  );
};

export default TawkToChat;
